<template>
    <div class="container">
        <v-card>
                <v-card-title class="titulopagina">ADMINISTRAR TURNOS</v-card-title>
                <v-card-text>
                    <v-btn color="green" fab small dark @click="crear">
                         <v-icon>add</v-icon>
                    </v-btn>
                </v-card-text>
                <!-- <Tabla :ajustes="this.ajustes" @editar="editar($event)"></Tabla> -->
            </v-card>

            <data-table class="mt-5" @editar="editar($event)" @eliminar="eliminar($event)"></data-table>
            <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>

            <modal @peticionrealizada="cargarDatos"></modal>
    </div>
</template>
<script>
import {mapState, mapMutations} from 'vuex';
import ConfirmDialogue from '@/components/ConfirmDialogue.vue'
//import Tabla from '@/components/shared/Tabla.vue'
import Data_Table from '@/components/shared/Data_Table.vue';
import Modal from '@/components/shared/Modal.vue';
// import axios from 'axios'
export default {
    data:()=>({
        lista:[],
        inputs:[
            {tipo:'texto',valor:'',label:'Nombre Turno*',key:'nombre_turno'},
            {tipo:'timer',valor:'',label:'Hora Inicio*',key:'hora_inicio',picker:false,index:0},
            {tipo:'timer',valor:'',label:'Hora Inicio*',key:'hora_fin',picker:false,index:1},
        ],
        configuracion_modal:{
            titulo_modal:'',
            boton_submit:'',
            ruta:'',
            tipo_peticion:''
        },
        //configuracion para datatable
        cabeceras:[
                {
                    text:'Turno',
                    align:'center',
                    sortable:true,
                    filterable:true,
                    value:'nombre_turno',
                    class:'cabecera'
                },
                {
                    text: 'Hora Inicio',
                    align: 'center',
                    sortable: true,
                    value: 'hora_inicio',
                    class:'cabecera'
                },
                {
                    text: 'Hora Fin',
                    align: 'center',
                    sortable: true,
                    value: 'hora_fin',
                    class:'cabecera'
                },
                { text: 'Acciones', value: 'action', sortable: false, align:'center', class:'cabecera' },
        ],
        acciones:[
                {key:'editar',titulo:'Editar',visible:true},
                {key:'eliminar',titulo:'Eliminar',visible:true, customDelete: true},
        ]
    }),
    mounted() {
        this.cargarDatos();
    },
    methods: {
        async cargarDatos(){
            //this.mostrarLoading('Cargando Datos...');
            this.mostrarLoading({titulo:'Cargando Datos...',color:'green'})

            let url = `${this.base_url}turnos`;
            await this.axios.get(url,this.headers).then((response)=>{
                console.log('respuesta',response);
                this.lista = response.data.data;
                // Event.$emit('actualizar_lista',this.lista);
                // Event.$emit('llenar_tabla',this.lista,this.cabeceras,this.acciones)
                Event.$emit('inicializar_tabla',this.cabeceras,this.lista,this.acciones);
                this.ocultarLoading();
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            });
        },
        crear(){
            console.log('crear');
            this.configuracion_modal.titulo_modal = 'Crear Turno';
            this.configuracion_modal.boton_submit = 'Crear';
            this.configuracion_modal.ruta = 'turnos';
            this.configuracion_modal.tipo_peticion = 'POST';
            this.$emit('abrir',this.inputs,this.configuracion_modal);
        },
        async editar($event){
            console.log('editando',$event);
            //por cada input se realiza el seteo correspondiente del item que se esta editando
            await this.inputs.forEach(input => {
                //recorrido del objeto a editar
                Object.keys($event).forEach(key => {
                    let valor = $event[key];
                    if(input.key == key){
                        input.valor = valor;
                    }
                });
            });

            console.log('inputs con datos a editar',this.inputs);
            this.configuracion_modal.titulo_modal = 'Editar Turno';
            this.configuracion_modal.boton_submit = 'Actualizar';
            this.configuracion_modal.ruta = `turnos/${$event.id}`;
            this.configuracion_modal.tipo_peticion = 'PUT';
            this.$emit('abrir',this.inputs,this.configuracion_modal);
        },
        async eliminar($event) {
            const url = `${this.base_url}turnos/${$event.id}`;
            const ok = await this.$refs.confirmDialogue.show({
                title: 'Confirmar eliminación',
                message: `¿Desea eliminar turno de ${$event.nombre_turno} (${$event.hora_inicio} - ${$event.hora_fin})?`,
                okButton: '¡Eliminar!',
            })
            if(ok) {
                this.mostrarLoading({titulo: `Eliminando turno ${$event.nombre_turno}...`, color: "red"});
                await this.axios.delete(url, this.headers).then((response) => {
                    console.log(response.data)
                    this.cargarDatos()
                    this.ocultarLoading();
                }).catch((error)=>{
                    console.log(error);
                    this.errorMessage(error, "Error al eliminar ");
                });
            }
        }, 
        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url','headers'])
    },
    components:{
        'modal':Modal,
        'data-table':Data_Table,
        ConfirmDialogue,
    }
}
</script>